import React from 'react'
import styled from '@emotion/styled'
import { colors, radius, shadow, spacing } from '@mobi/component-library/Theme/Common'
import type { Ticket } from '@core/Areas/AccountActivity/types'
import { BetInfo } from '@core/Areas/AccountActivity/Components/Ticket/Components/BetInfo'
import { TicketDisplayContext } from '@core/Areas/AccountActivity/context'
import { getTicketLayoutType } from '@core/Areas/AccountActivity/Components/Ticket/helpers/legTypes'

export const PendingTicket: React.FC<{
  ticket: Ticket
  isSelected: boolean
  onClick(ticketSequence: Ticket['ticketSequence']): void
}> = ({ ticket, isSelected, onClick }) => {
  const ticketTypeLayout = getTicketLayoutType(ticket)

  return (
    <WrapperStyled
      onClick={() => onClick(ticket.ticketSequence)}
      className={isSelected ? 'quick-share__ticket--selected' : ''}
    >
      <TicketDisplayContext.Provider
        value={{
          type: 'share',
          data: { shouldHideCost: true, display: 'betloop-quick-share', isSelected },
        }}
      >
        <div>
          <BetInfo ticket={ticket} status='Pending' ticketLayoutType={ticketTypeLayout} />
        </div>
      </TicketDisplayContext.Provider>
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.button({
  position: 'relative',
  padding: spacing.smx1,
  background: colors.white,
  borderRadius: radius.lgx1,
  border: `0.1rem solid ${colors.neutral[200]}`,
  boxShadow: shadow.xs,
  cursor: 'pointer',
  textAlign: 'unset',
  transition: 'all 0.3s ease',
  WebkitTapHighlightColor: 'transparent',

  '::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    transition: 'opacity 0.3s ease',
    borderRadius: 'inherit',
    border: `0.2rem solid ${colors.studio[500]}`,
    opacity: 0,
  },

  '&.quick-share__ticket--selected': {
    background: colors.lavender[50],

    '::before': { opacity: 1 },
  },

  '> div': {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.smx1,
    padding: spacing.smx2,

    background: 'white',
    borderRadius: radius.md,

    // Disable all interaction w/ display ticket
    pointerEvents: 'none',
  },
})
